<template>
	<div class="search-field">
		<v-text-field
			v-model="searchQuery"
			append-icon="search"
			clearable
			hide-details
			:color="dark ? 'white' : 'primary'"
			:placeholder="placeholder"
			type="text"
			:class="!dark ? 'primary--text' : 'white--text'"
		></v-text-field>
	</div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
	data() {
		return {};
	},

	props: {
		placeholder: {
			default: "Search"
		}
	},

	computed: {
		...mapGetters(["dark"]),

		...mapGetters({
			SEARCH_QUERY: "searchQuery"
		}),

		searchQuery: {
			get() {
				return this.SEARCH_QUERY;
			},

			set(value) {
				this.SET_VALUE({
					name: "searchQuery",
					value
				});
			}
		}
	},

	methods: {
		...mapMutations(["SET_VALUE"])
	},
};
</script>
